import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialDoiByTrialId: ITrialDoiLoadByTrialIdActionCreator = (trialId) => {
        return {
            type: ACTION_TRIALDOI_LOAD_BY_TRIAL_ID,
            trialId
        }
    },
    LoadTrialDoiById: ITrialDoiLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALDOI_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialDoiLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALDOI_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialDoiLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALDOI_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialDoi: ITrialDoiSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALDOI_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialDoiSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALDOI_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialDoiSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALDOI_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialDoi: ITrialDoiValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALDOI_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialDoiValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALDOI_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialDoiValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALDOI_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateTrialDoi: ITrialDoiCreateActionCreator = (trialId) => {

        return {
            type: ACTION_TRIALDOI_CREATE,
            trialId
        }
    },
    CreateSuccess: ITrialDoiCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALDOI_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialDoiCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALDOI_CREATE_FAILURE,
            responseStatus
        }
    },

    SyncTrialDoi: ITrialDoiSyncActionCreator = (trialId) => {

        return {
            type: ACTION_TRIALDOI_SYNC,
            trialId
        }
    },
    SyncSuccess: ITrialDoiSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALDOI_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: ITrialDoiSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALDOI_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialDoiClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALDOI_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialDoiFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALDOI_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALDOI_LOAD_BY_TRIAL_ID = "ACTION_TRIALDOI_LOAD_BY_TRIAL_ID",
    ACTION_TRIALDOI_LOAD_BY_ID = "ACTION_TRIALDOI_LOAD_BY_ID",
    ACTION_TRIALDOI_LOAD_SUCCESS = "ACTION_TRIALDOI_LOAD_SUCCESS",
    ACTION_TRIALDOI_LOAD_FAILURE = "ACTION_TRIALDOI_LOAD_FAILURE",

    ACTION_TRIALDOI_SAVE = "ACTION_TRIALDOI_SAVE",
    ACTION_TRIALDOI_SAVE_SUCCESS = "ACTION_TRIALDOI_SAVE_SUCCESS",
    ACTION_TRIALDOI_SAVE_FAILURE = "ACTION_TRIALDOI_SAVE_FAILURE",

    ACTION_TRIALDOI_VALIDATE = "ACTION_TRIALDOI_VALIDATE",
    ACTION_TRIALDOI_VALIDATE_SUCCESS = "ACTION_TRIALDOI_VALIDATE_SUCCESS",
    ACTION_TRIALDOI_VALIDATE_FAILURE = "ACTION_TRIALDOI_VALIDATE_FAILURE",

    ACTION_TRIALDOI_CREATE = "ACTION_TRIALDOI_CREATE",
    ACTION_TRIALDOI_CREATE_SUCCESS = "ACTION_TRIALDOI_CREATE_SUCCESS",
    ACTION_TRIALDOI_CREATE_FAILURE = "ACTION_TRIALDOI_CREATE_FAILURE",

    ACTION_TRIALDOI_SYNC = "ACTION_TRIALDOI_SYNC",
    ACTION_TRIALDOI_SYNC_SUCCESS = "ACTION_TRIALDOI_SYNC_SUCCESS",
    ACTION_TRIALDOI_SYNC_FAILURE = "ACTION_TRIALDOI_SYNC_FAILURE",

    ACTION_TRIALDOI_CLEAR = "ACTION_TRIALDOI_CLEAR",

    ACTION_TRIALDOI_FILTER = "ACTION_TRIALDOI_FILTER";

export interface ITrialDoiLoadByTrialIdAction {
    type: "ACTION_TRIALDOI_LOAD_BY_TRIAL_ID";
    trialId: number;
}

export interface ITrialDoiLoadByTrialIdActionCreator {
    (trialId: number): ITrialDoiLoadByTrialIdAction;
}

export interface ITrialDoiLoadSuccessAction {
    type: "ACTION_TRIALDOI_LOAD_SUCCESS";
    formData: Dtos.TrialDoi | Dtos.TrialDoi[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialDoiLoadSuccessActionCreator {
    (
        formData: Dtos.TrialDoi | Dtos.TrialDoi[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialDoiLoadSuccessAction;
}

export interface ITrialDoiLoadFailureAction {
    type: "ACTION_TRIALDOI_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialDoiLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialDoiLoadFailureAction;
}

export interface ITrialDoiLoadByIdAction {
    type: "ACTION_TRIALDOI_LOAD_BY_ID";
    id: number;
}

export interface ITrialDoiLoadByIdActionCreator {
    (id: number): ITrialDoiLoadByIdAction;
}

export interface ITrialDoiSaveAction {
    type: "ACTION_TRIALDOI_SAVE";
    formData: Dtos.TrialDoi;

}

export interface ITrialDoiSaveActionCreator {
    (
        formData: Dtos.TrialDoi
    ): ITrialDoiSaveAction;
}

export interface ITrialDoiSaveSuccessAction {
    type: "ACTION_TRIALDOI_SAVE_SUCCESS";
    formData: Dtos.TrialDoi;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialDoiSaveSuccessActionCreator {
    (
        formData: Dtos.TrialDoi,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialDoiSaveSuccessAction;
}

export interface ITrialDoiSaveFailureAction {
    type: "ACTION_TRIALDOI_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialDoiSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialDoiSaveFailureAction;
}

export interface ITrialDoiValidateAction {
    type: "ACTION_TRIALDOI_VALIDATE";
    formData: Dtos.TrialDoi;

}

export interface ITrialDoiValidateActionCreator {
    (
        formData: Dtos.TrialDoi
    ): ITrialDoiValidateAction;
}

export interface ITrialDoiValidateSuccessAction {
    type: "ACTION_TRIALDOI_VALIDATE_SUCCESS";
    formData: Dtos.TrialDoi;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialDoiValidateSuccessActionCreator {
    (
        formData: Dtos.TrialDoi,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialDoiValidateSuccessAction;
}

export interface ITrialDoiValidateFailureAction {
    type: "ACTION_TRIALDOI_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialDoiValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialDoiValidateFailureAction;
}

export interface ITrialDoiCreateAction {
    type: "ACTION_TRIALDOI_CREATE",
    trialId: number
}

export interface ITrialDoiCreateActionCreator {
    (trialId: number): ITrialDoiCreateAction
}

export interface ITrialDoiCreateSuccessAction {
    type: "ACTION_TRIALDOI_CREATE_SUCCESS";
    formData: Dtos.TrialDoi;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ITrialDoiCreateSuccessActionCreator {
    (
        formData: Dtos.TrialDoi,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialDoiCreateSuccessAction;
}

export interface ITrialDoiCreateFailureAction {
    type: "ACTION_TRIALDOI_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialDoiCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialDoiCreateFailureAction;
}

export interface ITrialDoiClearAction {
    type: "ACTION_TRIALDOI_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialDoiClearActionCreator {
    (propertiesToClear?: string[]): ITrialDoiClearAction;
}

export interface ITrialDoiFilterActionCreator {
    (formFilter: IFormFilter): ITrialDoiFilterAction;
}

export interface ITrialDoiFilterAction {
    type: "ACTION_TRIALDOI_FILTER";
    formFilter: IFormFilter;
}

export interface ITrialDoiSyncAction {
    type: "ACTION_TRIALDOI_SYNC",
    trialId: number
}

export interface ITrialDoiSyncActionCreator {
    (trialId: number): ITrialDoiSyncAction
}

export interface ITrialDoiSyncSuccessAction {
    type: "ACTION_TRIALDOI_SYNC_SUCCESS";
    formData: Dtos.TrialDoi[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialDoiSyncSuccessActionCreator {
    (
        formData: Dtos.TrialDoi[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialDoiSyncSuccessAction;
}

export interface ITrialDoiSyncFailureAction {
    type: "ACTION_TRIALDOI_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialDoiSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialDoiSyncFailureAction;
}

export type TrialDoiAction =
    ITrialDoiLoadByTrialIdAction |
    ITrialDoiLoadByIdAction |
    ITrialDoiLoadFailureAction |
    ITrialDoiLoadSuccessAction |
    ITrialDoiSaveAction |
    ITrialDoiSaveSuccessAction |
    ITrialDoiSaveFailureAction |
    ITrialDoiValidateAction |
    ITrialDoiValidateSuccessAction |
    ITrialDoiValidateFailureAction |
    ITrialDoiCreateAction |
    ITrialDoiCreateSuccessAction |
    ITrialDoiCreateFailureAction |
    ITrialDoiSyncAction |
    ITrialDoiSyncSuccessAction |
    ITrialDoiSyncFailureAction |
    ITrialDoiClearAction | 
    ITrialDoiFilterAction;
